import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const schema = z.object({
  flowId: z.number().optional(),
  flowName: z.string().min(1, "Can't be empty"),
  app: z.string().min(1, "Can't be empty"),
  platform: z.string().min(1, "Can't be empty"),
  url: z.string().min(1, "Can't be empty"),
  defaultFacebookPageId: z.number({
    required_error: "Can't be empty",
  }),
  defaultCreativeTextId: z.number({
    required_error: "Can't be empty",
  }),
  additionalFacebookPagesIds: z.number().array().default([]),
  additionalCreativeTextsIds: z.number().array().default([]),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
